exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/core-js/library/modules/_wks-ext.js
// module id = 120
// module chunks = 0